// UI route, resource type, API route, and optional query parameter for its ID.
// Ownership comes from the API, never from a team_id in the URL.
const RECORD_ROUTES = [
  [/^\/post\/([^/]+)$/, "post", "/post/:id"],
  [/^\/prospects\/([^/]+)$/, "prospect", "/prospects/:id"],
  [/^\/prospect_articles\/([^/]+)$/, "prospect", "/prospect_articles/:id"],
  [/^\/([^/]+)\/similar_articles$/, "similar", "/aggregates/:id/similar_articles"],
  [/^\/reports\/(?:ai-report|custom-report)\/([^/]+)$/, "report", "/reports/:id"],
  [/^\/team\/lists\/([^/]+)$/, "linkedin_list", "/linkedin_prospect/list/:id"],
  [/^\/import_prospects\/([^/]+)$/, "prospect_import", "/prospect_import/:id"],
  [/^\/search\/([^/]+)$/, "search_space", "/search_spaces/:id"],
  [/^\/admin\/smart_publish$/, "matching_article", "/aggregates/smart_articles", "smart_id"],
];

export function recordRoute(path) {
  const url = new URL(path, window.location.origin);
  const pathname = url.pathname.replace(/\/$/, "");
  if (pathname === "/prospects/archived") return null;
  for (const [pattern, type, api, idParam] of RECORD_ROUTES) {
    const match = pathname.match(pattern);
    if (!match) continue;
    const id = idParam ? url.searchParams.get(idParam) : decodeURIComponent(match[1]);
    if (id) return { type, id, apiPath: api.replace(":id", id), idParam };
  }
  return null;
}

export const currentPath = () => window.location.pathname + window.location.search + window.location.hash;

export function matchesResource(path, resource) {
  const route = recordRoute(path);
  return route && route.id === String(resource?.id) &&
    (route.type === resource?.type || (route.type === "similar" && ["post", "matching_article"].includes(resource?.type)));
}

export function safeDestination(path, fallback = "/feed") {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//") || /[\\\r\n]/.test(path)) return fallback;
  return path;
}

export const refreshDestination = path => recordRoute(path) ? "/team/home" : new URL(path, window.location.origin).pathname;

export function isRecordRead(config, path) {
  const route = recordRoute(path);
  if (!route || (config.method || "get").toLowerCase() !== "get") return false;
  const url = new URL(config.url, window.location.origin);
  return url.pathname === route.apiPath && (!route.idParam ||
    String(config.params?.[route.idParam] || url.searchParams.get(route.idParam)) === route.id);
}
